// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1094":"456a0f0b793e453c2c87","1236":"13a8ebe673bc385c1af3"}[chunkId] + ".js";
};